import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { OpendialogAddClubComponent } from 'app/components/dialog/open-dialog-add-club/opendialog-add-club.component';
import { ClubDetails } from 'app/shared/models/class/club/club';
import { ClubService } from 'app/shared/services/club/club.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';

@Component({
  selector: 'app-admin-clubs',
  templateUrl: './admin-clubs.component.html',
  styleUrls: ['./admin-clubs.component.scss']
})

export class AdminClubsComponent implements OnInit {

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  displayedColumns: string[] = ['clubCode', 'logo', 'clubName', 'federation', 'details', 'edit'];
  dataSource: MatTableDataSource<ClubDetails>;

  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;

  color: ThemePalette = 'primary';

  clubs: any = [];

  searchForm: UntypedFormGroup;
  valueInput: string;

  isLoading = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private dialog: MatDialog,
    private clubService: ClubService,
    private tooltip: TooltipService,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.getClubs();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  applyFilter(filterValue): void {
    this.valueInput = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.valueInput = '';
    this.applyFilter(this.valueInput);
  }

  openDialogAddClub(actionDialog: string, clubUpdate?: ClubDetails): void {
    const dialogRef = this.dialog.open(OpendialogAddClubComponent, {
      data: { action: actionDialog, club: clubUpdate || null },
      disableClose: true,
      height: '80%',
      width: '80%'
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => { res ? this.getClubs() : null }
    });
  }

  isActivatedOrDeactivated(offerKey: string, isActive: boolean): void {
    const newIsActive = !isActive;
  }

  getTooltip(value: string): string {
    return this.tooltip.getTooltip(value);
  }

  getLogoClub(logo: string): string {
    return `data:image/png;base64,${logo}`;
  }

  private getClubs(): void {
    this.isLoading = true;
    this.clubService.getClubDetails().subscribe({
      next: clubs => {
        this.clubs = clubs.sort((a, b) => a.clubCode.localeCompare(b.clubCode));
        this.dataSource = new MatTableDataSource(this.clubs);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isLoading = false;
      }
    });
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }
}
